import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import "../Pages.css";
import Billede1 from "../../Images/Billede1.jpg";
import HeroSectionV2 from "../../components/HeroSectionV2";
import EventUserDashboard from "../../components/EventUserDashboard";
import { Center, Text } from "@mantine/core";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
    const { language } = useLanguage();
    const navigate = useNavigate();

    const personId =
        sessionStorage.getItem("personId") ||
        sessionStorage.getItem("PersonID") ||
        sessionStorage.getItem("personID");

    return (
        <div className="home">
            <HeroSectionV2
                titleEn="UserDashboard"
                titleDa="Brugeradgang"
                descriptionEn="Your overview of registered shifts across events."
                descriptionDa="Dit overblik over tilmeldte vagter på tværs af events."
                badgeText="Profil"
                imageSrc={Billede1}
            />



            {!personId ? (
                <Center mt="lg">
                    <Text>
                        {language === "da"
                            ? "Log ind for at se dit overblik."
                            : "Log in to see your dashboard."}
                    </Text>
                </Center>
            ) : (
                    <>
                        <EventUserDashboard
                            language={language}
                            defaultCollapsed={true}
                        />

                        <Center mt="xl">
                            <Button
                                size="lg"
                                radius="xl"
                                color="red"
                                onClick={() => navigate("/")}
                            >
                                {language === "da"
                                    ? "Tilmeld dig flere vagter"
                                    : "Sign up for more shifts"}
                            </Button>
                        </Center>
                    </>
            )
        }
        </div>
    );
};

export default Home;
